import React, { useEffect, useState } from "react";
import SummaryApi from "../common";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../helpers/AuthContext";
import logo from "../asset/logo.png";   // ✅ your logo

const StudentCategorySelection = () => {
  const navigate = useNavigate();
  const { academicCourse } = useAuth();

  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const formatImageUrl = (imagePath) => {
    if (!imagePath) return "";
    const baseUrl = SummaryApi.Images.url.replace("/api", "");
    if (imagePath.startsWith("http")) return imagePath;
    return `${baseUrl}/${imagePath}`;
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(SummaryApi.getActiveCategories.url);
        const result = await res.json();

        if (result.status && Array.isArray(result.data)) {
          setCategories(result.data);
        } else {
          console.error("Unexpected API response:", result);
        }
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    if (academicCourse === "degree" || academicCourse === "Degree") {
      setFilteredCategories(
        categories.filter((c) => c.is_degree_category === 1)
      );
    } else {
      setFilteredCategories(categories);
    }
  }, [categories, academicCourse]);

  useEffect(() => {
    const savedCategoryId = sessionStorage.getItem("selectedCategoryId");
    if (savedCategoryId) {
      setSelectedCategory(savedCategoryId);
    }
  }, []);

  return (
<div
  className="
    relative flex flex-col items-center justify-center w-full min-h-screen
    bg-white font-inter text-white
  "
>

  {/* 🌟 TOP CENTERED LOGO (NEW WRAPPER, NO CODE REMOVED) */}
  <div className="w-full flex justify-center mt-6 mb-4">
    <img
      src={logo}
      alt="bg-logo"
      className="
        w-40 sm:w-48 md:w-56 lg:w-64 
        object-contain
      "
    />
  </div>


  {/* 🌟 WIZARD CONTAINER */}
  {/* 🌟 WIZARD CONTAINER */}
  <div
    className="
      relative z-10 bg-[#1C3664] shadow-2xl rounded-2xl
      w-[80%] mt-6 mb-16 px-6 sm:px-8 md:px-10 lg:px-12 py-20 
      overflow-hidden
    "
  >




    {/* CONTENT WRAPPER */}
    <div className="relative z-20 text-white">

      {/* HEADER */}
      <div className="text-center mb-8">
        <h2 className="text-[32px] sm:text-[36px] md:text-[38px] font-bold mb-2 text-white">
          CATEGORIES
          <span className="block w-16 h-[3px] bg-white mx-auto mt-1 relative">
            <span className="block w-2 h-2 bg-white rotate-45 absolute -bottom-1 left-1/2 -translate-x-1/2"></span>
          </span>
        </h2>

        <h3 className="text-[#e69818] text-[20px] sm:text-[22px] font-bold mb-2">
          Choose Your Learning Path
        </h3>

        <p className="text-[16px] sm:text-[17px] opacity-90 text-white">
          Select the category that interests you the most
        </p>
      </div>

      {/* CATEGORY GRID */}
      <div className="
        grid grid-cols-1 
        sm:grid-cols-2 
        md:grid-cols-3 
        xl:grid-cols-4 
        gap-6 sm:gap-8
      ">

        {filteredCategories.map((category) => (
          <label
            key={category.category_id}
            className={`
              cursor-pointer p-6 rounded-xl shadow-md border text-center flex flex-col 
              items-center justify-center transition-all duration-300 bg-white
  ${
  selectedCategory === String(category.category_id)
    ? "scale-105 border-2 border-[#e69818] shadow-xl"
    : "border border-transparent hover:border-[#e69818] hover:shadow-lg"
}

            `}
          >
            <input
              type="radio"
              name="category"
              value={category.category_id}
              checked={selectedCategory === String(category.category_id)}
              onChange={() => {
                const id = String(category.category_id);
                setSelectedCategory(id);
                sessionStorage.setItem("selectedCategoryId", id);
              }}
              className="hidden"
            />

            <img
              src={formatImageUrl(category.category_image)}
              alt="Category"
              className="w-16 h-16 object-cover rounded-md mb-4"
            />

            <h3 className="text-lg font-semibold mb-1 text-[#1C3664]">
              {category.category_name}
            </h3>

            <p className="text-sm opacity-80 text-[#1C3664]">
              {category.total_courses || 0}+ Courses
            </p>
          </label>
        ))}

      </div>

      {/* NAV BUTTONS */}
      <div className="w-full mt-12 flex justify-between px-2">
        <button
          type="button"
          className="
            border border-white text-white rounded-md py-3 px-6 text-lg font-medium 
            hover:bg-white hover:text-[#1C3664] transition shadow-md
          "
        >
          &lt; Back
        </button>

        <button
          type="button"
          className={`
            rounded-md py-3 px-8 text-lg font-medium shadow-md transition 
            ${
              selectedCategory
                ? "bg-blue-500 text-white hover:bg-blue-600"
                : "bg-gray-400 text-white cursor-not-allowed"
            }
          `}
          disabled={!selectedCategory}
          onClick={() => {
            navigate("/student-panel/course-selection", {
              state: { selectedCategoryId: selectedCategory },
            });
          }}
        >
          Next &gt;
        </button>
      </div>

    </div> {/* END content wrapper */}
  </div> {/* END container */}
</div>

  );
};

export default StudentCategorySelection; 
